import { LodgingRequestReportExcelState, LodgingRequestReportExcelActionTypes, LODGING_REQUEST_REPORT_EXCEL_REQUEST, LODGING_REQUEST_REPORT_EXCEL_SUCCESS, LODGING_REQUEST_REPORT_EXCEL_FAILURE } from "store/reducers/lodgingRequest/getReportExcel/types";

const defaultState: LodgingRequestReportExcelState = {
  isLoading: false,
  errorMessage: ""
};

export default function getReportExcel(state = defaultState, action: LodgingRequestReportExcelActionTypes): LodgingRequestReportExcelState {
  switch (action.type) {
    case LODGING_REQUEST_REPORT_EXCEL_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case LODGING_REQUEST_REPORT_EXCEL_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case LODGING_REQUEST_REPORT_EXCEL_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};